<template>
  <div
    class="container-fluid small_screen_effect_container"
    style="position: relative"
  >
    <WalletHeader />

    <div class="small_screen_effect_inner wallet_balance_page">
      <div class="row">
        <div class="col-md-6" id="LargeBalancee">
          <MyWalletBalance />
        </div>

        <div style="margin: 20px">
          <button
            class="relsify-button"
            style="
              padding-block: 14px;
              padding-inline: 20px;
              font-size: 14px;
              display: flex;
              gap: 8px;
              align-items: center;
            "
            @click="$router.push({ name: 'WalletConvert' })"
          >
            Convert coins
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 24 24"
              height="20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path fill="none" d="M0 0h24v24H0V0z"></path>
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z"
              ></path>
            </svg>
          </button>
        </div>
        <div class="col-xl-12">
          <div class="transcHistory">
            <router-link
              :to="{
                name: 'UserTransactionHistory',
              }"
              class="page-breadcrum"
            >
              Transaction History
            </router-link>
          </div>
          <WalletTabs />
          <WalletFilters />
          <div class="page-tab-content">
            <div class="relsify-tab-pane active" id="walletBalance">
              <WalletBalance />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/dashboard.css";
import WalletBalance from "@/components/wallet/wallet-balance/WalletBalance.vue";
import "@/mixins";
import { mapActions } from "vuex";
import MyWalletBalance from "../../components/extras/MyWalletBalance.vue";
import WalletFilters from "../../components/wallet/WalletFilters.vue";
import WalletTabs from "../../components/wallet/WalletTabs.vue";
import WalletHeader from "./WalletHeader.vue";

export default {
  components: {
    WalletHeader,
    WalletTabs,
    WalletBalance,
    MyWalletBalance,
    WalletFilters,
  },

  methods: {
    ...mapActions(["setCurrentPageName", ""]),
  },
  mounted() {
    this.closeMarketPlace();
    this.setCurrentPageName(this.$router.currentRoute._rawValue.name);
    // this.fillData();
  },
};
</script>

<style scoped>
@media screen and (max-width: 580px) {
  .container-fluid .small_screen_effect_inner .row {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
